import React from "react";
import FavoriteCard from "./FavoriteCard";
import { useDispatch } from "react-redux";
import { deleteFavPhoto } from '../redux/userSlice';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const FavoriteList = ({ isLoaded, favoriteList, handleAddFavorite, handleDeleteFavorite }) => {

    var settings = {
        dots: true,
        infinite: false,
        speed: 500,
        slidesToShow: 4,
        slidesToScroll: 4,
        initialSlide: 0,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 3,
              infinite: true,
              dots: true
            }
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2,
              initialSlide: 2
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
        ]
      };

    const dispatch = useDispatch();

    if (!isLoaded) return <h2 className="loading">Loading...</h2>;

    const handleDeleteClick = (e) => {
        const id = e.target.id
        fetch(`https://fotoset.herokuapp.com/favorites/${id}`, {
          method: "DELETE",
      })
      .then(r => r.json())
      .then((favPhoto) => {
          handleDeleteFavorite(favPhoto)
          dispatch(deleteFavPhoto(favPhoto))
      })
  }

    const favoriteItems = favoriteList.map((fav) =>  
        <div id="fav-container" key={fav.id}> 
            <FavoriteCard
            location={fav.photo.location} 
            image={fav.photo.image}
            id={fav.photo.id}
            handleAddFavorite={handleAddFavorite}
            />
            <div className="remove">
                <button id={fav.id} className="remove-btn" onClick={handleDeleteClick}>Remove</button>
            </div>
        </div> 
        )

    return(
      <>
        <h1 style={{color: "#ff2e4c", marginBottom: "0"}}>My Favorite</h1>
        <hr></hr>
        <div className="favorite-card">
            <Slider {...settings}>
                {favoriteList ? favoriteItems : "loading"}
            </Slider>
        </div>
        <hr></hr>
     </>

    )
}

export default FavoriteList;